// Studyo Today Backend
// Package studyo.today.subscriptions.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/subscriptions/v1/resources/entitlement_scope.proto (package studyo.today.subscriptions.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/subscriptions/v1/resources/entitlement_scope.proto.
 */
export const file_studyo_today_subscriptions_v1_resources_entitlement_scope = /*@__PURE__*/
  fileDesc("Cj9zdHVkeW8vdG9kYXkvc3Vic2NyaXB0aW9ucy92MS9yZXNvdXJjZXMvZW50aXRsZW1lbnRfc2NvcGUucHJvdG8SJ3N0dWR5by50b2RheS5zdWJzY3JpcHRpb25zLnYxLnJlc291cmNlcypyChBFbnRpdGxlbWVudFNjb3BlEiEKHUVOVElUTEVNRU5UX1NDT1BFX1VOU1BFQ0lGSUVEEAASHQoZRU5USVRMRU1FTlRfU0NPUEVfUExBTk5FUhABEhwKGEVOVElUTEVNRU5UX1NDT1BFX1NDSE9PTBACQi+qAixTdHVkeW8uVG9kYXkuU3Vic2NyaXB0aW9ucy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.subscriptions.v1.resources.EntitlementScope.
 */
export const EntitlementScopeSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_subscriptions_v1_resources_entitlement_scope, 0);

/**
 * Represents something that the user is allowed to do based on his current subscription plan.
 *
 * @generated from enum studyo.today.subscriptions.v1.resources.EntitlementScope
 */
export const EntitlementScope = /*@__PURE__*/
  tsEnum(EntitlementScopeSchema);

